import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getConfig } from "plugins/config-loader";
const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: getConfig("REACT_APP_TAGS_BASE_URL"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.oidc?.user?.access_token;
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        createTags: builder.mutation({
            invalidatesTags: ["Tags"],
            query: (request) => ({
                body: request,
                method: "POST",
                url: "tags"
            })
        }),
        deleteTags: builder.mutation({
            invalidatesTags: ["Tags"],
            query: ({ ids }) => {
                const params = new URLSearchParams();
                for (const id of ids) {
                    params.append("ids", id.toString());
                }
                return {
                    method: "DELETE",
                    url: `tags?${params.toString()}`
                };
            }
        }),
        fetchTags: builder.query({
            providesTags: ["Tags"],
            query: (request) => ({
                method: "GET",
                params: request,
                url: "tags"
            })
        })
    }),
    reducerPath: "tags",
    tagTypes: ["Tags"]
});
export const { middleware: tagsApiMiddleware, reducer: tagsApiReducers, reducerPath: tagsApiReducersPath, useCreateTagsMutation, useDeleteTagsMutation, useFetchTagsQuery } = api;
